import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
// import router from './router';
import store from './store';

import Game from './game';
import audio from './scripts/audio';
import translate from './scripts/translate';
import eventHub from './scripts/eventHub';
import {
  getLang,
  sendGAEvent,
  inApp,
  isLogged,
  isBrowser,
} from './scripts/utils';

Vue.config.productionTip = false;

Vue.prototype.$game = new Game();
Vue.prototype.$audio = audio;
Vue.prototype.$translate = (key) => translate(key, getLang());
Vue.prototype.$sendEvent = sendGAEvent;
Vue.prototype.$eventHub = eventHub;
Vue.prototype.$inApp = inApp() && !isBrowser();
Vue.prototype.$isLogged = isLogged();
Vue.prototype.$isBrowser = isBrowser();

new Vue({
  // router,
  store,
  render: (h) => h(App),
}).$mount('#app');
